/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Coach_BodyInputs */

const en_portal_coach_body = /** @type {(inputs: Portal_Coach_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Running your own clients, schedule and payments happens in the coach app.`)
};

const pl_portal_coach_body = /** @type {(inputs: Portal_Coach_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swoich klientów, grafik i płatności prowadzisz w aplikacji dla trenerów.`)
};

/**
* | output |
* | --- |
* | "Running your own clients, schedule and payments happens in the coach app." |
*
* @param {Portal_Coach_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_coach_body = /** @type {((inputs?: Portal_Coach_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Coach_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_coach_body(inputs)
	return en_portal_coach_body(inputs)
});